import data from "../../shared/sharedData";

export default {
  name: "Appendix C - Additional Contact Information",
  pageInfo: {
    text: "Pursuant to 20 CFR 655.130(a), the employer or joint employer (as applicable) must disclose to the Department the identity, location and contact information of all owners of each employer, the operators of each place of employment (if different than the employer(s)), and all managers and supervisors of workers employed under the job order associated with this application, regardless whether those managers or supervisors are employed by the employer(s) or another entity.<br/><br/>\
    <em>Important Note:</em> Each employer, any joint employer, and each operator of any place of employment identified on the job order (Form ETA-790/790A), must be identified in each section of “Additional Contact Information.”  If more than three (3) persons need to be identified, the employer must complete as many additional Appendix C forms as are necessary to provide a complete response.",
    coloring: "grey",
  },
  sections: [
    {
      code: "Appendix C",
      machine_name: "additionalContacts",
      isModal: true,
      removeFromFieldArray: true,
      openModalHeader: "Add Additional Contact Information",
      modalHeader: "Add Additional Contact Information",
      sectionHeader: "Additional Contact Information",
      listType: "table",
      validate: ["tableRequired", "tableIncomplete"],
      removeLink: "Remove Additional Contact Information",
      modalFields: [
        {
          hideOnTable: true,
          isGroup: {
            code: "1",
            required: true,
            label: "Role of person (select all that apply)",
            tooltip: `Enter the role of the individual identified in this section, defined below for purposes of compliance with 20 CFR § 655.130(a) - Mark all boxes that apply.<br/><br/><b>Owner - Employer:</b> The Department will consider a person or entity an owner if the person or entity legally owns or is an owner with a controlling operational role in the employer(s) business. The Department will require the employer to disclose the majority owners, defined as an owner with ownership of more than 50 percent of a business, and any owner who owns less than 50 percent of an organization, but exercises any decision-making responsibilities over the business. If the owner or operator of the place(s) of employment is a branch, subsidiary, or affiliate of a parent corporate or joint venture, the employer must list the owners and operators of the parent entity. The employer must provide this information for all debarred owners, regardless of ownership stake or level of control.<br/>\
            The Department considers the totality of the circumstances surrounding the business formation and conduct of the owner in determining ownership of an entity. Some examples demonstrating ownership are official State, local, or Federal documentation (e.g., articles of incorporation, business license, deed, etc.) documenting the ownership of an entity. Another example determining entity ownership is whether a judicial or administrative decision or action makes a definitive determination about ownership of an entity. If an individual or entity is listed as an owner or operator of the places of employment or the employing entity on an official Federal, State, or local document, like incorporation documents, or judicial or administrative records like those that indicate transfer of ownership, the Department expects the employer to provide identifying information for these individuals or entities. In many cases, this information will be publicly available on State or local websites.  Select this option if the individual identified in this section is the owner of the employing agricultural business.<br/><br/>\
            <b>Operator:</b> An operator is a person who runs the agricultural business, making day-to-day management decisions. An operator could be an owner, hired manager, cash tenant, share tenant, and/or a partner. If land is rented or worked on shares, the tenant or renter is an operator.  Select this option if the individual identified in this section is the operator of a place of employment where the employer’s workers will perform agricultural labor or services. The employer must provide this information for all debarred operators<br/><br/>\
            <b>Manager:</b> A manager is a person whose duties and responsibilities include formulating policies, managing daily operations, and planning the use of materials and human resources.  Select this option if the individual identified in this section is the manager of the agricultural workers.<br/><br/>\
            <b>Supervisor:</b> A supervisor is a person who supervises and coordinates the activities of agricultural, range, aquaculture, and related workers. Select this option if the individual identified in this section is the supervisor of agricultural workers.`,
            required: true,
            machine_name: "appendixAGroup",
            fields: [
              {
                machine_name: "ownerRole",
                widget: "checkbox_old",
                value: "YES",
                choice: "Owner - Employer",
                validate: [
                  {
                    subsetOfSetRequired: "add_values_field",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      numRequired: 1,
                      fieldArray: [
                        "ownerRole",
                        "operatorRole",
                        "managerRole",
                        "supervisorRole",
                      ],
                    },
                  },
                ],
                tooltip:
                  "The Department will consider a person or entity an owner if the person or entity legally owns or is an owner with a controlling operational role in the employer(s) business. The Department will require the employer to disclose the majority owners, defined as an owner with ownership of more than 50 percent of a business, and any owner who owns less than 50 percent of an organization, but exercises any decision-making responsibilities over the business. If the owner or operator of the place(s) of employment is a branch, subsidiary, or affiliate of a parent corporate or joint venture, the employer must list the owners and operators of the parent entity. The employer must provide this information for all debarred owners, regardless of ownership stake or level of control.<br/><br/>\
                  The Department considers the totality of the circumstances surrounding the business formation and conduct of the owner in determining ownership of an entity. Some examples demonstrating ownership are official State, local, or Federal documentation (e.g., articles of incorporation, business license, deed, etc.) documenting the ownership of an entity. Another example determining entity ownership is whether a judicial or administrative decision or action makes a definitive determination about ownership of an entity. If an individual or entity is listed as an owner or operator of the places of employment or the employing entity on an official Federal, State, or local document, like incorporation documents, or judicial or administrative records like those that indicate transfer of ownership, the Department expects the employer to provide identifying information for these individuals or entities. In many cases, this information will be publicly available on State or local websites.  Select this option if the individual identified in this section is the owner of the employing agricultural business.",
              },
              {
                machine_name: "operatorRole",
                widget: "checkbox_old",
                value: "YES",
                choice: "Operator",
                tooltip:
                  "The Department will consider a person or entity an owner if the person or entity legally owns or is an owner with a controlling operational role in the employer(s) business. The Department will require the employer to disclose the majority owners, defined as an owner with ownership of more than 50 percent of a business, and any owner who owns less than 50 percent of an organization, but exercises any decision-making responsibilities over the business. If the owner or operator of the place(s) of employment is a branch, subsidiary, or affiliate of a parent corporate or joint venture, the employer must list the owners and operators of the parent entity. The employer must provide this information for all debarred owners, regardless of ownership stake or level of control.<br/><br/>\
                  The Department considers the totality of the circumstances surrounding the business formation and conduct of the owner in determining ownership of an entity. Some examples demonstrating ownership are official State, local, or Federal documentation (e.g., articles of incorporation, business license, deed, etc.) documenting the ownership of an entity. Another example determining entity ownership is whether a judicial or administrative decision or action makes a definitive determination about ownership of an entity. If an individual or entity is listed as an owner or operator of the places of employment or the employing entity on an official Federal, State, or local document, like incorporation documents, or judicial or administrative records like those that indicate transfer of ownership, the Department expects the employer to provide identifying information for these individuals or entities. In many cases, this information will be publicly available on State or local websites.  Select this option if the individual identified in this section is the owner of the employing agricultural business.",
              },
              {
                machine_name: "managerRole",
                widget: "checkbox_old",
                value: "YES",
                choice: "Manager",
                tooltip:
                  "The Department will consider a person or entity an owner if the person or entity legally owns or is an owner with a controlling operational role in the employer(s) business. The Department will require the employer to disclose the majority owners, defined as an owner with ownership of more than 50 percent of a business, and any owner who owns less than 50 percent of an organization, but exercises any decision-making responsibilities over the business. If the owner or operator of the place(s) of employment is a branch, subsidiary, or affiliate of a parent corporate or joint venture, the employer must list the owners and operators of the parent entity. The employer must provide this information for all debarred owners, regardless of ownership stake or level of control.<br/><br/>\
                  The Department considers the totality of the circumstances surrounding the business formation and conduct of the owner in determining ownership of an entity. Some examples demonstrating ownership are official State, local, or Federal documentation (e.g., articles of incorporation, business license, deed, etc.) documenting the ownership of an entity. Another example determining entity ownership is whether a judicial or administrative decision or action makes a definitive determination about ownership of an entity. If an individual or entity is listed as an owner or operator of the places of employment or the employing entity on an official Federal, State, or local document, like incorporation documents, or judicial or administrative records like those that indicate transfer of ownership, the Department expects the employer to provide identifying information for these individuals or entities. In many cases, this information will be publicly available on State or local websites.  Select this option if the individual identified in this section is the owner of the employing agricultural business.",
              },
              {
                machine_name: "supervisorRole",
                widget: "checkbox_old",
                value: "YES",
                choice: "Supervisor",
                tooltip:
                  "The Department will consider a person or entity an owner if the person or entity legally owns or is an owner with a controlling operational role in the employer(s) business. The Department will require the employer to disclose the majority owners, defined as an owner with ownership of more than 50 percent of a business, and any owner who owns less than 50 percent of an organization, but exercises any decision-making responsibilities over the business. If the owner or operator of the place(s) of employment is a branch, subsidiary, or affiliate of a parent corporate or joint venture, the employer must list the owners and operators of the parent entity. The employer must provide this information for all debarred owners, regardless of ownership stake or level of control.<br/><br/>\
                  The Department considers the totality of the circumstances surrounding the business formation and conduct of the owner in determining ownership of an entity. Some examples demonstrating ownership are official State, local, or Federal documentation (e.g., articles of incorporation, business license, deed, etc.) documenting the ownership of an entity. Another example determining entity ownership is whether a judicial or administrative decision or action makes a definitive determination about ownership of an entity. If an individual or entity is listed as an owner or operator of the places of employment or the employing entity on an official Federal, State, or local document, like incorporation documents, or judicial or administrative records like those that indicate transfer of ownership, the Department expects the employer to provide identifying information for these individuals or entities. In many cases, this information will be publicly available on State or local websites.  Select this option if the individual identified in this section is the owner of the employing agricultural business.",
              },
            ],
          },
        },
        {
          code: "3",
          machine_name: "businessName",
          altFieldIfPresent: "otherBusinessName",
          label: "Legal Business Name",
          widget: "select",
          isInlineModal: true,
          selection: (formApi) => {
            const values =
              formApi
                .getState()
                .values?.linkedAgBusinessData?.map((x) => x.businessName) ?? [];
            values?.push("Other");

            return [false, values];
          },
          dynamicUpdates: [
            {
              set: "fein",
              fromFieldArray: "linkedAgBusinessData",
              findValueByChosen: "businessName",
            },
          ],
          clearSchema: [
            "address1",
            "address2",
            "city",
            "state",
            "country",
            "postalCode",
            "province",
            "otherFein",
            "otherBusinessName",
          ],
          required: true,
          validate: ["required"],
          maxLength: 120,
          tooltip: `Enter the full legal name of the business that the person identified in this section owns, operates, or works for.  The full legal name is the exact name of the individual, corporation, LLC, partnership, or other organization that is reported to the Internal Revenue Service (IRS).  If the entity is not the employer, you may leave this area blank.`,
          info: {
            text: `
            Select an employer from the Form ETA 790/790A OR select "Other" to enter a new employer, in the below dropdown.
            `,
            coloring: "grey",
            divider: false,
            position: "top",
            css: {
              marginTop: 20,
              marginBottom: 10,
            },
          },
        },
        {
          code: "3.a",
          machine_name: "otherBusinessName",
          label: "Other Legal Business Name",
          hideOnTable: true,
          widget: "text",
          isVisible: {
            when: "businessName",
            is: "Other",
            prefix: "add_values_field",
          },
          required: true,
          validate: ["required", { minLength: 2 }],
          tooltip: `Enter the full legal name of the business that the person identified in this section owns, operates, or works for.  The full legal name is the exact name of the individual, corporation, LLC, partnership, or other organization that is reported to the Internal Revenue Service (IRS).  If the entity is not the employer, you may leave this area blank.`,
        },
        {
          code: "2",
          tableHeader: "FEIN",
          machine_name: "fein",
          altFieldIfPresent: "otherFein",
          label: "FEIN (from IRS)",
          disabled: true,
          widget: "text",
          isVisible: {
            when: "businessName",
            is: ["Other"],
            prefix: "add_values_field",
            operator: "!==",
          },
          validate: ["required", "fein"],
          maxLength: 10,
          tooltip: `Enter the nine-digit Federal Employer identification Number (FEIN) as assigned by the IRS.  Do not enter a social security number.  Note:  All employers, including private households, \
            MUST obtain an FEIN from the IRS before completing this application. Information on obtaining an FEIN can be found at <a href="https://www.irs.gov/">www.irs.gov</a>`,
        },
        {
          code: "2.a",
          machine_name: "otherFein",
          label: "Other FEIN (from IRS)",
          hideOnTable: true,
          widget: "text",
          isVisible: {
            when: "businessName",
            is: "Other",
            prefix: "add_values_field",
          },
          required: true,
          validate: ["required", "fein", { minLength: 10 }],
          parse: "fein",
          maxLength: 10,
          tooltip: `Enter the nine-digit Federal Employer identification Number (FEIN) as assigned by the IRS.  Do not enter a social security number.  Note:  All employers, including private households, \
            MUST obtain an FEIN from the IRS before completing this application. Information on obtaining an FEIN can be found at <a href="https://www.irs.gov/">www.irs.gov</a>`,
        },
        {
          code: "4",
          tableHeader: "Last Name",
          machine_name: "lastName",
          label: "Contact's Last (family) Name",
          widget: "text",
          required: true,
          validate: ["required"],
          maxLength: 120,
          tooltip: `Enter the last (family) name of the individual identified in this section.  If the individual identified in this section has two last names, enter the primary last name first.`,
        },
        {
          code: "5",
          tableHeader: "First Name",
          machine_name: "firstName",
          label: "First (given) Name",
          widget: "text",
          required: true,
          validate: ["required"],
          maxLength: 120,
          tooltip: `Enter the first (given) name of the individual identified in this section.`,
        },
        {
          code: "6",
          hideOnTable: true,
          machine_name: "middleName",
          label: "Middle Name(s) §",
          widget: "text",
          maxLength: 120,
          tooltip: `Enter the middle name(s) of the individual identified in this section, if applicable.  Enter “N/A” if not applicable.`,
        },
        {
          hideOnTable: true,
          widget: "generic_prefill_button",
          label:
            "Click to prefill address information based on chosen legal business name",
          text: "Prefill Address Info",
          isVisible: {
            when: "businessName",
            is: ["Other", "- Select -", undefined, null, ""],
            prefix: "add_values_field",
            operator: "!==",
          },
          onClick: (formApi) => {
            const modalValues =
              formApi.getState().values?.add_values_field?.[0];
            const foundAgInfo = formApi
              .getState()
              .values?.linkedAgBusinessData?.find(
                (info) => info.businessName === modalValues.businessName
              );
            if (!!foundAgInfo) {
              Object.keys(foundAgInfo).forEach((fieldName) => {
                modalValues[fieldName] = foundAgInfo[fieldName];
              });
              formApi.change("add_values_field", [modalValues]);
            }
          },
        },
        {
          code: "7",
          hideOnTable: true,
          machine_name: "address1",
          label: "Address 1",
          widget: "text",
          required: true,
          validate: ["required"],
          info: {
            text: "Enter the business street address of the employer’s point of contact. A P.O. Box is a mailing address and not a valid physical address location and, when disclosed on this application, the CO will issue a NOD requesting removal of the P.O. Box mailing address and provide the employer with an opportunity to amend the application with a valid physical address location.",
            coloring: "grey",
            divider: false,
            css: {
              marginTop: 20,
              marginBottom: 10,
            },
          },
          maxLength: 120,
          tooltip: `Enter the street address of the individual identified in this section.  The address must be a physical location and not a Post Office (P.O.) Box.  A P.O. Box is a mailing address and not a valid physical address location and, when disclosed on this application, the CO will issue a NOD requesting removal of the P.O. Box mailing address and provide the employer with an opportunity to amend the application with a valid physical address location.`,
        },
        {
          code: "8",
          hideOnTable: true,
          machine_name: "address2",
          label: "Address 2 (apt/suite/floor and number) §",
          widget: "text",
          maxLength: 120,
          tooltip: `If additional space is needed for the street address, use this line to complete the employer’s street address.  If no additional space if needed, enter “N/A” or leave blank.`,
        },
        {
          code: "9",
          tableHeader: "City",
          machine_name: "city",
          label: "City or Town",
          widget: "text",
          required: true,
          validate: ["required"],
          maxLength: 120,
          tooltip: `Enter the city or town in which the individual identified in this section is located. If the geographic location does not have a city or town designation, enter “N/A.”`,
        },
        {
          code: "12",
          machine_name: "country",
          widget: "select",
          label: "Country",
          selection: data.country,
          required: true,
          validate: ["required"],
          isInlineModal: true,
          clearSchema: ["state"],
          tooltip: `Enter the country in which the individual identified in this section is located.`,
        },
        {
          code: "10",
          tableHeader: "State",
          machine_name: "state",
          label: "State/District/Territory",
          widget: "select",
          selection: data.state,
          state: true,
          required: true,
          validate: ["required"],
          isVisible: {
            when: "add_values_field[0]country",
            is: "UNITED STATES OF AMERICA",
          },
          tooltip: `Enter the State, District, or Territory in which the individual identified in this section is located.  If the geographic location does not have a State, District, or Territory designation, enter “N/A.”`,
        },
        {
          code: "11",
          hideOnTable: true,
          machine_name: "postalCode",
          widget: "text",
          label: "Postal Code",
          required: true,
          validate: ["required", "postal"],
          maxLength: 10,
          tooltip: `Enter the postal (zip) code in which the individual identified in this section is located.  If the geographic location does not have a postal code designation, enter “N/A.”`,
        },
        {
          code: "13",
          hideOnTable: true,
          machine_name: "province",
          label: "Province §",
          widget: "text",
          maxLength: 120,
          tooltip: `Enter the province in which the individual identified in this section is located, if applicable.  If the geographic location does not have a province designation, enter “N/A.”`,
        },
        {
          hideOnTable: true,
          isGroup: {
            required: true,
            label: "Do you know this person’s Date of Birth?",
            tooltip: `The Employer is reminded that it must exercise due diligence when gathering, disclosing and updating as necessary, this required information. If after a good faith effort to obtain this information, the Employer is unable to ascertain the Date of Birth at the time of filing, please enter “No” to this question. By entering in “No”, the system will automatically fill the date as 88/88/8888 to fulfill the instruction requirements.`,
            required: true,
            machine_name: "hasDOB",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                parent_machine_name: "add_values_field",
                clearSchema: ["dob"],
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                parent_machine_name: "add_values_field",
                clearSchema: ["dob"],
                validate: ["required"],
              },
            ],
          },
        },
        {
          code: "14",
          hideOnTable: true,
          machine_name: "dob",
          label: "Date of Birth",
          widget: "date",
          isVisible: {
            when: "hasDOB",
            is: "YES",
            prefix: "add_values_field",
          },
          required: true,
          validate: [
            "required",
            {
              noFutureDateModal: "dob",
              needsFieldValues: true,
              extraData: {
                prefix: "add_values_field",
              },
            },
          ],
          tooltip: `Enter the Date of Birth of the individual identified in this section.  Use a month/day/full year (MM/DD/YYYY) format. The Employer is reminded that it must exercise due diligence when gathering, disclosing and updating as necessary, this required information. If after a good faith effort to obtain this information, the Employer is unable to ascertain the Date of Birth at the time of filing, please enter 88/88/8888.`,
        },
        {
          code: "15",
          hideOnTable: true,
          machine_name: "phoneNumber",
          widget: "phone",
          label: "Telephone Number",
          required: true,
          validate: ["required", "phone"],
          maxLength: 15,
          tooltip: `Enter the area code and telephone number for the individual identified in this section used for business purposes.  Include country code, if outside the United States.`,
        },
        {
          code: "16",
          hideOnTable: true,
          machine_name: "phoneExt",
          widget: "text",
          label: "Extension §",
          validate: ["number"],
          parse: "positiveWholeNumber",
          maxLength: 4,
          tooltip: `Enter the extension of the telephone number for the individual identified in this section used for business purposes, if applicable.`,
        },
        {
          code: "17",
          hideOnTable: true,
          machine_name: "email",
          widget: "text",
          label: "Email Address",
          required: true,
          validate: [
            "required",
            {
              email: {
                extraData: {
                  allowNAs: false,
                  isInlineModal: true,
                },
              },
            },
          ],
          maxLength: 55,
          tooltip: `Enter the email address of the individual identified in this section used for business purposes. Format must be <a href='#!' target='_blank'>name@emailaddress.top-leveldomain</a>.`,
        },
      ],
    },
  ],
};
